type Variables = { [key: string]: any };
type Headers = { [key: string]: string };

export async function gqlRequest(
    url: string,
    query: string,
    variables: Variables = {},
    headers: Headers = {}
): Promise<any> {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...headers
        },
        body: JSON.stringify({
            query,
            variables
        })
    });

    if (response.ok) {
        const data = await response.json();
        return data;
    } else {
        const errorText = await response.text();
        throw new Error(`Query failed with status code ${response.status}. ${errorText}`);
    }
}